import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { RouteLink, useCurrentRoute } from '../lib/router';
import { WhatsAppButton } from './WhatsAppButton';
const NAV_ITEMS = [{
  label: 'Home',
  to: '/'
}, {
  label: 'Stay Overnight',
  to: '/stay'
}, {
  label: 'Pines Membership',
  to: '/membership'
}, {
  label: 'Retreat Space',
  to: '/space'
}];
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const currentRoute = useCurrentRoute();
  return <header className="sticky top-0 z-50 border-b border-pine/10 bg-cream/95 backdrop-blur-md" data-id="element-235" data-mp="qx5k7ur4pfn6">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-10" data-id="element-236" data-mp="14w55qtjchef4">
        <RouteLink to="/" className="font-serif text-xl tracking-wide text-pine transition-colors hover:text-ember md:text-2xl" aria-label="Pines Retreat home" data-id="element-237" data-mp="zwsocob8szjx">
          Pines Retreat
        </RouteLink>

        <nav aria-label="Primary navigation" className="hidden items-center gap-7 lg:flex" data-id="element-238" data-mp="2bda8pq1kfbq7">
          {NAV_ITEMS.map(item => <RouteLink key={item.to} to={item.to} className={`text-sm font-medium tracking-wide transition-colors ${currentRoute === item.to ? 'text-ember' : 'text-pine hover:text-ember'}`} data-id="element-239" data-mp="29jafp879ju5r">
              {item.label}
            </RouteLink>)}
        </nav>

        <div className="hidden lg:block" data-id="element-240" data-mp="2ohcktmty0np4"><WhatsAppButton variant="compact" label="WhatsApp Zev" data-id="element-241" data-mp="2ogkq0e866tzw" /></div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-pine/20 text-pine transition-colors hover:border-pine hover:bg-pine/5 lg:hidden" aria-expanded={menuOpen} aria-controls="mobile-navigation" aria-label={menuOpen ? 'Close navigation' : 'Open navigation'} data-id="element-242" data-mp="1qu3wlk2k50jf">
          {menuOpen ? <X className="h-5 w-5" data-id="element-243" data-mp="1832u4m28amv4" /> : <Menu className="h-5 w-5" data-id="element-244" data-mp="181rvf0nn45av" />}
        </button>
      </div>

      {menuOpen && <nav id="mobile-navigation" aria-label="Mobile navigation" className="border-t border-pine/10 bg-cream px-5 py-5 lg:hidden" data-id="element-245" data-mp="1d14edabe4s86">
          <div className="mx-auto flex max-w-7xl flex-col gap-1" data-id="element-246" data-mp="14zeyyzqd4tsr">
            {NAV_ITEMS.map(item => <RouteLink key={item.to} to={item.to} onClick={() => setMenuOpen(false)} className={`rounded-sm px-4 py-3 text-base font-medium transition-colors ${currentRoute === item.to ? 'bg-pine text-cream' : 'text-pine hover:bg-pine/5'}`} data-id="element-247" data-mp="1002cwh7bfqr8">
                {item.label}
              </RouteLink>)}
            <WhatsAppButton variant="primary" label="Message Zev on WhatsApp" className="mt-3 w-full" data-id="element-248" data-mp="m46yoonv33u6" />
          </div>
        </nav>}
    </header>;
}